import React, { useEffect, useRef } from 'react';
import { gql } from '@apollo/react-hooks';
import DataGrid from '#/common/components/DataGrid';
import { getSyncHistoryList } from '#/graphql/queries';
import columns from './columns';
import { useNavigate } from 'react-router-dom';

const getSyncHistoryListQuery = gql(getSyncHistoryList);

const SyncHistoryDataGrid: React.FC = () => {
  const dgRef = useRef<any>(null);
  const refreshTimer = useRef<ReturnType<typeof setInterval> | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    refreshTimer.current = setInterval(() => {
      dgRef.current?.instance?.refresh?.();
    }, 30_000);

    return () => {
      if (refreshTimer.current) clearInterval(refreshTimer.current);
    };
  }, []);

  return (
    <DataGrid
      id="sync-history"
      pluralText="Sync History Records"
      singularText="Sync History"
      actions={['clear-filters', 'refresh-data', 'column-chooser']}
      columns={columns}
      getItemsQuery={getSyncHistoryListQuery}
      setRef={(ref) => {
        dgRef.current = ref;
      }}
      selectionMode="none"
    />
  );
};

export default SyncHistoryDataGrid;
